import React from 'react'
import PropTypes from 'prop-types'

import Tooltip from 'Pods/Shared/Tooltip'

import UserSidebarDataRow from './UserSidebarDataRow'
import RankTooltip from './Tooltips/RankTooltip'
import RatingTooltip from './Tooltips/RatingTooltip'

function UserSidebarDataRows(props) {
  if (props.dataRow.title === 'Rating') {
    return (
      <div>
        <Tooltip
          id="user-ratings__tooltip"
          content={<RatingTooltip rating={props.userRating} userRatings={props.userRatings} />}
          place="bottom"
          wrapperClassName="user-rating__tooltip-wrapper"
          className="user-rating__tooltip"
        >
          <UserSidebarDataRow dataRow={props.dataRow} isWithTooltip />
        </Tooltip>
      </div>
    )
  } if (props.dataRow.title === 'Reputation') {
    return props.dataRow.data ? (
      props.userLevel ? (
        <div>
          <Tooltip
            id="user-ranks__tooltip"
            content={
              props.userLevel ? <RankTooltip userLevel={props.userLevel} /> : ''
            }
            place="bottom"
            wrapperClassName="user-rating__tooltip-wrapper"
            className="user-rating__tooltip"
          >
            <UserSidebarDataRow dataRow={props.dataRow} isWithTooltip />
          </Tooltip>
        </div>
      ) : (
        <UserSidebarDataRow dataRow={props.dataRow} />
      )
    ) : null
  }
  return (
    <div>
      <Tooltip
        id={`user-info-${props.index}`}
        content={props.dataRow.tooltipText}
        place="bottom"
        wrapperClassName="user-rating__tooltip-wrapper"
        className="user-rating__tooltip"
      >
        <UserSidebarDataRow dataRow={props.dataRow} isWithTooltip />
      </Tooltip>
    </div>
  )
}

UserSidebarDataRows.propTypes = {
  dataRow: PropTypes.shape({
    title: PropTypes.string.isRequired,
    data: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.element,
      PropTypes.string,
    ]),
  }).isRequired,
  userLevel: PropTypes.string,
  userRating: PropTypes.number,
  userRatings: PropTypes.object,
  index: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
}

export default UserSidebarDataRows
